import { defineStore } from "pinia"
import { type ApiResponse } from "~/types/api"
import { type Blockchain } from "~/models/blockchain"

export const useBlockchainStore = defineStore("blockchain", () => {
	const state = {
		blockchains: ref<Blockchain[] | null>(null)
	}

	const getAllBlockchains = async () => {
		const data = await $fetch<GetAllBlockchainResponse>(GetAllBlockchain.url(), {
			...useFetchConfig(),
			method: GetAllBlockchain.method
		})
		return data.data
	}

	const createBlockchain = async (formData: CreateBlockchainRequest) => {
		const data = await $fetch<CreateBlockchainResponse>(CreateBlockchain.url(), {
			...useFetchConfig(),
			method: CreateBlockchain.method,
			body: formData
		})
		state.blockchains.value = [...(state.blockchains.value || []), data.data]
		return data.data
	}

	const editBlockchain = async (formData: EditBlockchainRequest) => {
		const data = await $fetch<EditBlockchainResponse>(EditBlockchain.url(), {
			...useFetchConfig(),
			method: EditBlockchain.method,
			body: formData
		})
		state.blockchains.value = state.blockchains.value?.map((b) => (b.id == data.data.id ? data.data : b)) || null
		return data.data
	}

	return {
		...state,
		getAllBlockchains,
		editBlockchain,
		createBlockchain
	}
})

// blockchain :: create blockchain
export interface CreateBlockchainRequest {
	name: string
	slug: string
	token_standard?: string
	force_show_standard?: boolean
	address_format?: string
	hash_format?: string
	hash_explorer?: string
	is_address_case_sensitive: boolean
	is_hash_case_sensitive: boolean
	image_id?: number | null
	coin_id?: number | null
	status: "enable" | "disable"
}
export interface CreateBlockchainResponse extends ApiResponse {
	data: Blockchain
}
const CreateBlockchain = {
	method: "POST" as const,
	url: () => `blockchains/create`
}

// blockchain :: edit blockchain
export interface EditBlockchainRequest {
	id: number
	name?: string
	slug?: string
	token_standard?: string
	force_show_standard?: boolean
	address_format?: string
	hash_format?: string
	hash_explorer?: string
	is_address_case_sensitive?: boolean
	is_hash_case_sensitive?: boolean
	image_id?: number | null
	coin_id?: number | null
	status?: "enable" | "disable"
}
export interface EditBlockchainResponse extends ApiResponse {
	data: Blockchain
}
const EditBlockchain = {
	method: "POST" as const,
	url: () => `blockchains/edit`
}

// blockchain :: get all blockchain
export interface GetAllBlockchainRequest {}
export interface GetAllBlockchainResponse extends ApiResponse {
	data: Blockchain[]
}
const GetAllBlockchain = {
	method: "GET" as const,
	url: () => `blockchains/all`
}

export const useBlockchainApiUrl = () => ({
	EditBlockchain,
	GetAllBlockchain
})
